import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Account } from '../models/account.model';

interface DialogDeleteAccountConfig {
  account: Account;
}

@Component({
  selector: 'app-delete-account-dialog',
  templateUrl: './delete-account-dialog.component.html',
})
export class DeleteAccountDialogComponent implements OnInit {
  account: Account;
  params: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDeleteAccountConfig,
  ) {}

  ngOnInit() {
    this.account = this.data.account;
  }

  checkedChange(accountKey: string, formValue: boolean) {
    this.params[accountKey] = formValue;
  }
}
